// extracted by mini-css-extract-plugin
module.exports = {"_frame":"NpRechner__frame__2SsgH"};